// MANISH CUSTOM CODE - HEADER SHRINK ON SCROLL (manish-cc) - START
// Adds a class to #header-component once the page has scrolled past a
// small threshold, removed back near the top. CSS in layout/theme.liquid
// uses that class to shrink the logo and reduce header padding.
//
// FIX (this update): this theme hydrates/re-renders the header section
// client-side shortly after the initial HTML paint (see the `hydrate()`
// call in sections/header.liquid). That can replace the #header-component
// node with a new one. The previous version of this script cached a
// single reference to that element at startup — if hydration swapped in
// a fresh node afterward, every later classList.toggle() call kept
// mutating the old, now-detached element, which is invisible to the
// user. This is a very plausible explanation for it working on one
// device/timing and not another. Fix: never cache the element — always
// look it up fresh at the moment we need it, so it's always the live,
// currently-rendered node no matter when/whether hydration replaced it.

(function () {
  var THRESHOLD = 24; // px scrolled before the header starts shrinking
  var ticking = false;

  function applyState() {
    ticking = false;
    var header = document.getElementById('header-component');
    if (!header) return;

    var shouldShrink = window.scrollY > THRESHOLD;
    if (shouldShrink) {
      header.classList.add('manish-cc-header-shrink');
    } else {
      header.classList.remove('manish-cc-header-shrink');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(applyState);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', applyState);
  document.addEventListener('shopify:section:load', applyState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }
})();

// MANISH CUSTOM CODE - HEADER SHRINK ON SCROLL (manish-cc) - END
